module.exports = __webpack_public_path__ + "static/media/data_science 2.57a833b4.svg";